import _typeof from "@babel/runtime/helpers/esm/typeof";
import fixControlledValue from './fixControlledValue';
import interopDefault from './interopDefault';
import isWindow from './isWindow';
import noop from './noop';
import prettyBytes from './prettyBytes';
import canUseDom from "rc-util/es/Dom/canUseDom";
export { isDoc, isPpt, isXls, isPdf, isImage, isAudio, isVideo, isArchive } from './file';
export { getContentType, getFileName, getId, getImageName, getWindowHeight, getWindowWidth } from './getter';
export { blobToDataURL, canvasToImage, dataURLtoFile } from './converter';
export { fixControlledValue, interopDefault, isWindow, noop, prettyBytes };
export var RICH_TEXT_BLANK = '<p><br></p>';
export var TEXT_BLANK = '';
export function sleep() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return new Promise(function (resolve) {
    return setTimeout(resolve, time);
  });
}
export var isFunction = function isFunction(val) {
  return typeof val === 'function';
};
export var isObject = function isObject(val) {
  return val !== null && _typeof(val) === 'object';
};
export var isPromise = function isPromise(val) {
  return isObject(val) && isFunction(val.then) && isFunction(val.catch);
};
export function isDocumentVisible() {
  if (canUseDom()) {
    return document.visibilityState !== 'hidden';
  }

  return true;
}
export function wrapIfNotArr(v) {
  return Array.isArray(v) ? v : [v];
}